<template>
    <page>
        <div class="shadow-25" v-if="mockData && form">
            <v-header :title="$metaInfo.title" icon="note add"/>
            <card width="100%">

                <form @submit.prevent="onSubmit"
                      class="row gutter-sm"
                      @keydown="form.onKeydown($event)">

                    <v-autocomplete path="lendingKit"
                                    resource-path="v1/available-lending-kits"
                                    key="lendingKit"
                                    v-model="form.lendingKit"
                                    :label="$t('lending kit')"
                                    :item-plural="$t('lending kits')"
                                    :map="item => ({
                                        label: `${this.$T('codentify')}:  ${item.codentify}`,
                                        value: item,
                                        sublabel: `${this.$T('child codentify 1')}: ${item.child_codentify_1}, ${this.$T('child codentify 2')}: ${item.child_codentify_2}`
                                    })"
                                    @input="(item) => takeLendingKitInfo(item)"
                                    :form="form"
                                    class="col-md-6 col-sm-6 col-xs-12">
                    </v-autocomplete>

                    <template v-if="lendingKit">

                        <v-display v-model="lendingKit['product_model.description']"
                                   :label="$t('product model')"
                                   :form="form"
                                   class="col-md-6 col-sm-6 col-xs-12">
                        </v-display>

                        <v-display v-model="lendingKit['product_color.description']"
                                   :label="$t('product color')"
                                   :form="form"
                                   class="col-md-6 col-sm-6 col-xs-12">
                        </v-display>


                        <v-display v-model="lendingKit.child_codentify_1"
                                   :label="$t('child codentify 1')"
                                   :form="form"
                                   class="col-md-6 col-sm-6 col-xs-12">
                        </v-display>

                        <v-display v-model="lendingKit.child_codentify_2"
                                   :label="$t('child codentify 2')"
                                   :form="form"
                                   class="col-md-6 col-sm-6 col-xs-12">
                        </v-display>

                        <v-display v-if="(user.role.name === 'Lending Point' || user.role.name === 'Sales Expert' || user.role.name === 'MUPI' || user.role.name === 'Remote Coach')" v-model="myLendingPoint"
                                   :label="$t('lending point')"
                                   :form="form"
                                   class="col-md-6 col-sm-6 col-xs-12">
                        </v-display>
                        <v-select v-else v-model="form.lending_point_id"
                                   :label="$t('lending point')"
                                   :options="mockData['lendingPoints']"
                                   :form="form"
                                   class="col-md-6 col-sm-6 col-xs-12">
                        </v-select>


                        <v-select
                            :label="$t('ownership')"
                            v-model="form.owner_id"
                            :options="mockData['owners']"
                            :form="form"
                            :disable="disableOwnership"
                            class="col-md-6 col-sm-6 col-xs-12">

                        </v-select>
                        <v-display v-model="lendingKit['stock_status.description']"
                                   :label="$t('stock status')"
                                   :form="form"
                                   class="col-md-6 col-sm-6 col-xs-12">
                        </v-display>

                    </template>
                    <!-- Submit Button -->
                    <div class="col-12 row justify-center q-mt-md">
                        <v-button :label="$T('save')"
                                  color="primary"
                                  class="no-shadow q-btn-iqos"
                                  :loading="form.busy"
                                  :disable="form.busy"
                                  @click.native.prevent="onSubmit">
                            <template slot="loading">
                                <q-spinner-puff class="on-left" color="white"></q-spinner-puff>
                                {{ $T('saving...') | capitalize }}
                            </template>
                        </v-button>
                    </div>

                </form>
            </card>

        </div>
        <div class="row justify-center items-center row-spinner-height" v-else>
            <spinner-iqos size="60px"/>
        </div>
    </page>
</template>

<script>
    import Form from 'vform'
    import axios from 'axios'
    import {
        QSpinnerPuff,
        QSlideTransition
    } from 'quasar-framework'
    import VDisplay from "../../components/form/VDisplay";
    import VAutocomplete from "../../components/form/VAutocomplete";
    import VSelect from "../../components/form/VSelect";
    import lendingKitModel from "../lendingKitModel";
    import {mapGetters} from "vuex";

    export default {
        middleware: 'auth',

        mixins: [lendingKitModel],
        metaInfo() {
            return {title: this.$T("add new lending kit")}
        },

        components: {
            VSelect,
            VAutocomplete,
            VDisplay,
            QSpinnerPuff,
            QSlideTransition
        },

        data() {
            return {
                mockData: null,
                form: {},
                lendingKit: {
                    'product_model.description': null,
                    'product_color.description': null,
                    'stock_status.description': null,
                },
                disableOwnership: false
            }
        },


        methods: {
            async setup() {
                await this.getMockData()
                this.lendingKit =  {
                    'product_model.description': null,
                    'product_color.description': null,
                    'stock_status.description': null,
                }

                this.form = new Form({
                    // owner_id: (this.user.role.name === 'Lending Point' || this.user.role.name === 'Sales Expert') ? 2 : 1,
                    owner_id: this.user.market.abbreviation == 'AD' ? 3 : (this.user.role.name === 'Lending Point' || this.user.role.name === 'Sales Expert' || this.user.role.name === 'MUPI' || this.user.role.name === 'Remote Coach') ? 2 : 1,
                    lending_point_id: this.user.lending_point_id
                })
                this.disableOwnership = (this.user.role.name === 'Lending Point' || this.user.role.name === 'Sales Expert' || this.user.role.name === 'MUPI' || this.user.role.name === 'Remote Coach')
            },
            takeLendingKitInfo(item) {
                if(item) {
                    this.lendingKit = item
                } else {
                    this.setup()
                }
            },

            /**
             * Loads the "mock data" from the store
             */
            async getMockData() {
                const {data} = await axios.get(`${config.appUrl}/api/lending-kit/form-mock-data`)
                this.mockData = data.data
            },

            async onSubmit() {
                if (this.form.busy) return
                let response = await this.form.post(`/api/v1/lending-point/lending-kit/add`)
                if (!response.data) return
                let {data} = response
                this.$q.dialog({
                    title: this.$T('success'),
                    message: data.success.message,
                    preventClose: true,
                    stackButtons: false,
                    ok: {
                        label: this.$T('go to list'),
                        outline: true,
                        rounded: true,
                        color: 'primary',
                        noCaps: true
                    },
                    cancel: {
                        color: 'highlight',
                        label: `${this.$T('new lending kit')}`,
                        rounded: true,
                        textColor: 'primary',
                        noCaps: true
                    }
                }).then(() => {
                    this.$router.push({name: (this.user.role.name === 'Sales Expert' || this.user.role.name === 'MUPI' || this.user.role.name === 'Remote Coach') ? 'sales-expert.lending-kits' : 'lending-point.lending-kits'})
                }).catch(() => {
                    this.setup()
                })
            }
        },
        computed: {
            ...mapGetters({
                user: 'auth/user'
            }),
            myLendingPoint() {
                return (this.user.hasOwnProperty('lending_point')) ? this.user.lending_point.description : 'N.A.'
            }
        },
        mounted() {
            this.setup()
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/device/addLendingKit.vue